import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';

const supportedLanguages: string[] = ['af', 'am', 'ar', 'as', 'az', 'bg', 'bn-IN', 'bs', 'ca', 'ca-ES-valencia', 'cs', 'cy', 'da', 'de', 'el', 'en', 'en-GB', 'es', 'es-MX', 'et', 'eu','fa', 'fi', 'fil', 'fr', 'fr-CA', 'ga', 'gd', 'gl', 'gu', 'he', 'hi', 'hr', 'hu', 'hy', 'id', 'is', 'it', 'ja', 'ka', 'kk', 'km-KH', 'kn', 'ko', 'kok', 'lb', 'lo', 'lt', 'lv', 'mi', 'mk', 'ml', 'mr', 'ms', 'mt', 'nb-NO', 'ne', 'nl', 'nn-NO', 'or', 'pa', 'pl', 'pt-BR', 'pt-PT', 'quz', 'ro', 'ru', 'sk', 'sl', 'sq', 'sr-Cyrl-BA', 'sr-Cyrl-RS', 'sr-Latn-RS', 'sv', 'ta', 'te', 'th', 'tr', 'tt', 'ug', 'uk', 'ur', 'uz-Latn-UZ', 'vi', 'zh-Hans', 'zh-Hant'];
const normalizedToCompleteLanguage: { [key: string]: string } = { 'bn': 'bn-IN', 'km': 'km-KH', 'nb': 'nb-NO', 'nn': 'nn-NO', 'pt': 'pt-BR', 'sr': 'sr-Cyrl-RS', 'uz': 'uz-Latn-UZ', 'zh': 'zh-Hans' };
const fallbackLanguage: string = 'en';

export const normalizeLanguageCode = (language: string): string|null => {
    if (supportedLanguages.includes(language)) {
        return language;
    }
    const shortLng = language.split('-')[0];
    if (supportedLanguages.includes(shortLng)) {
        return shortLng;
    }
    if (normalizedToCompleteLanguage[shortLng]) {
        return normalizedToCompleteLanguage[shortLng];
    }
    return null;
};

export const convertDetectedLanguage = (lng: string): string => {
    const normalizedLanguage = normalizeLanguageCode(lng);
    if (normalizedLanguage) {
        return normalizedLanguage;
    }
    const navLanguage = typeof navigator !== 'undefined' ? navigator.language : null;
    const normalizedNavLanguage = navLanguage ? normalizeLanguageCode(navLanguage) : null;
    if (normalizedNavLanguage) {
        return normalizedNavLanguage;
    }
    return fallbackLanguage;
}

i18next.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        supportedLngs: supportedLanguages,
        fallbackLng: fallbackLanguage,
        detection: {
            order: ["path", "navigator", "localStorage", "htmlTag"],
            caches: ["localStorage"],
            convertDetectedLanguage: (lng) => {
                return convertDetectedLanguage(lng);
            }
        },
        resources: {
            'af': {
                translations: require('./af/translations.json')
            },
            'am': {
                translations: require('./am/translations.json')
            },
            'ar': {
                translations: require('./ar/translations.json')
            },
            'as': {
                translations: require('./as/translations.json')
            },
            'az': {
                translations: require('./az/translations.json')
            },
            'bg': {
                translations: require('./bg/translations.json')
            },
            'bn-IN': {
                translations: require('./bn-IN/translations.json')
            },
            'bs': {
                translations: require('./bs/translations.json')
            },
            'ca': {
                translations: require('./ca/translations.json')
            },
            'ca-ES-valencia': {
                translations: require('./ca-Es-VALENCIA/translations.json')
            },
            'cs': {
                translations: require('./cs/translations.json')
            },
            'cy': {
                translations: require('./cy/translations.json')
            },
            'da': {
                translations: require('./da/translations.json')
            },
            'de': {
                translations: require('./de/translations.json')
            },
            'el': {
                translations: require('./el/translations.json')
            },
            'en': {
                translations: require('./en/translations.json')
            },
            'en-GB': {
                translations: require('./en-GB/translations.json')
            },
            'es': {
                translations: require('./es/translations.json')
            },
            'es-MX': {
                translations: require('./es-MX/translations.json')
            },
            'et': {
                translations: require('./et/translations.json')
            },
            'eu': {
                translations: require('./eu/translations.json')
            },
            'fa': {
                translations: require('./fa/translations.json')
            },
            'fi': {
                translations: require('./fi/translations.json')
            },
            'fil': {
                translations: require('./fil/translations.json')
            },
            'fr': {
                translations: require('./fr/translations.json')
            },
            'fr-CA': {
                translations: require('./fr-CA/translations.json')
            },
            'ga': {
                translations: require('./ga/translations.json')
            },
            'gd': {
                translations: require('./gd/translations.json')
            },
            'gl': {
                translations: require('./gl/translations.json')
            },
            'gu': {
                translations: require('./gu/translations.json')
            },
            'he': {
                translations: require('./he/translations.json')
            },
            'hi': {
                translations: require('./hi/translations.json')
            },
            'hr': {
                translations: require('./hr/translations.json')
            },
            'hu': {
                translations: require('./hu/translations.json')
            },
            'hy': {
                translations: require('./hy/translations.json')
            },
            'id': {
                translations: require('./id/translations.json')
            },
            'is': {
                translations: require('./is/translations.json')
            },
            'it': {
                translations: require('./it/translations.json')
            },
            'ja': {
                translations: require('./ja/translations.json')
            },
            'ka': {
                translations: require('./ka/translations.json')
            },
            'kk': {
                translations: require('./kk/translations.json')
            },
            'km-KH': {
                translations: require('./km-KH/translations.json')
            },
            'kn': {
                translations: require('./kn/translations.json')
            },
            'ko': {
                translations: require('./ko/translations.json')
            },
            'kok': {
                translations: require('./kok/translations.json')
            },
            'lb': {
                translations: require('./lb/translations.json')
            },
            'lo': {
                translations: require('./lo/translations.json')
            },
            'lt': {
                translations: require('./lt/translations.json')
            },
            'lv': {
                translations: require('./lv/translations.json')
            },
            'mi': {
                translations: require('./mi/translations.json')
            },
            'mk': {
                translations: require('./mk/translations.json')
            },
            'ml': {
                translations: require('./ml/translations.json')
            },
            'mr': {
                translations: require('./mr/translations.json')
            },
            'ms': {
                translations: require('./ms/translations.json')
            },
            'mt': {
                translations: require('./mt/translations.json')
            },
            'nb-NO': {
                translations: require('./nb-NO/translations.json')
            },
            'ne': {
                translations: require('./ne/translations.json')
            },
            'nl': {
                translations: require('./nl/translations.json')
            },
            'nn-NO': {
                translations: require('./nn-NO/translations.json')
            },
            'or': {
                translations: require('./or/translations.json')
            },
            'pa': {
                translations: require('./pa/translations.json')
            },
            'pl': {
                translations: require('./pl/translations.json')
            },
            'pt-BR': {
                translations: require('./pt-BR/translations.json')
            },
            'pt-PT': {
                translations: require('./pt-PT/translations.json')
            },
            'quz': {
                translations: require('./quz/translations.json')
            },
            'ro': {
                translations: require('./ro/translations.json')
            },
            'ru': {
                translations: require('./ru/translations.json')
            },
            'sk': {
                translations: require('./sk/translations.json')
            },
            'sl': {
                translations: require('./sl/translations.json')
            },
            'sq': {
                translations: require('./sq/translations.json')
            },
            'sr-Cyrl-BA': {
                translations: require('./sr-Cyrl-BA/translations.json')
            },
            'sr-Cyrl-RS': {
                translations: require('./sr-Cyrl-RS/translations.json')
            },
            'sr-Latn-RS': {
                translations: require('./sr-Latn-RS/translations.json')
            },
            'sv': {
                translations: require('./sv/translations.json')
            },
            'ta': {
                translations: require('./ta/translations.json')
            },
            'te': {
                translations: require('./te/translations.json')
            },
            'th': {
                translations: require('./th/translations.json')
            },
            'tr': {
                translations: require('./tr/translations.json')
            },
            'tt': {
                translations: require('./tt/translations.json')
            },
            'ug': {
                translations: require('./ug/translations.json')
            },
            'uk': {
                translations: require('./uk/translations.json')
            },
            'ur': {
                translations: require('./ur/translations.json')
            },
            'uz-Latn-UZ': {
                translations: require('./uz-Latn-UZ/translations.json')
            },
            'vi': {
                translations: require('./vi/translations.json')
            },
            'zh-Hans': {
                translations: require('./zh-Hans/translations.json')
            },
            'zh-Hant': {
                translations: require('./zh-Hant/translations.json')
            },
        },
        ns: ['translations'],
        defaultNS: 'translations',
        react: { useSuspense: false }
    });

i18next.languages = [fallbackLanguage];

export default i18next;